import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Firebase configuration with environment variable support
// IMPORTANT: The hardcoded values below are fallback defaults for the primary Firebase project.
// For production deployments or different environments, set REACT_APP_FIREBASE_* environment variables
// in your .env file or deployment platform (Vercel, etc.). See FIREBASE_AUTH_SETUP.md for details.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAbu92GCIBwX0hByr1Qtiyo2gMaFU9TPHY",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "rfq-app-v3.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "rfq-app-v3",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "rfq-app-v3.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "249596552876",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:249596552876:web:7bf790756dfc6070c0a109",
  ...(process.env.REACT_APP_FIREBASE_MEASUREMENT_ID && {
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
  }),
};

const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);

// Standard Database Connection (Removes the ForceLongPolling)
export const db = getFirestore(app);

// Firebase Authentication
export const auth = getAuth(app);

export default app;


